import { useState } from "react";

function VideoCard() {
  const [open, setOpen] = useState(false);
  const videoId = "YywPy6fKCNU";
  const thumb = "https://img.youtube.com/vi/YywPy6fKCNU/hqdefault.jpg";

  <img src={thumb} alt="Video thumbnail" />;

  return (
    <>
      {/* Preview card */}
      <div className="flex-1">
        <div
          className="bg-white rounded-lg shadow-lg overflow-hidden relative cursor-pointer"
          onClick={() => setOpen(true)}
        >
          <img
            src={thumb}
            alt="video preview"
            className="w-full h-[220px] sm:h-[300px] md:h-[320px] object-cover"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="bg-white/90 rounded-full p-3 shadow-lg">
              <svg
                className="w-8 h-8 text-green-600"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
          <div className="bg-transparent w-full max-w-4xl mx-auto">
            <div className="relative rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(false)}
                className="absolute top-3 right-3 z-50 bg-white/90 rounded-full p-2 shadow"
                aria-label="Close"
              >
                ✕
              </button>

              <div className="w-full h-[70vh] md:h-[75vh]">
                <iframe
                  className="w-full h-full"
                  src={`https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1`}
                  title="Customer Testimonial Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default VideoCard;
